import React from 'react';
import { NavLink } from 'react-router-dom';
import AdminAds from './AdminAds';

function AdminPanel() {
    return (
        <div className="page admin-panel-page">
            <header className="page-header">
                <span className="page-eyebrow">Admin</span>
                <h1>Admin dashboard</h1>
                <p className="page-subtitle">Quick access to analytics and administrative tools.</p>
            </header>

            <section className="panel admin-actions">
                <div style={{display:'flex',gap:12,flexWrap:'wrap',alignItems:'center'}}>
                    <NavLink to="/admin/ads" className={({isActive})=>`btn ${isActive? 'btn-primary' : 'btn-outline-secondary'}`} end>Ad analytics</NavLink>
                    <NavLink to="/admin/users" className={({isActive})=>`btn ${isActive? 'btn-primary' : 'btn-outline-secondary'}`}>Users</NavLink>
                    <NavLink to="/admin/payments" className={({isActive})=>`btn ${isActive? 'btn-primary' : 'btn-outline-secondary'}`}>Payments</NavLink>
                    <div style={{marginLeft:'auto'}} className="text-muted small">Note: server-side admin gating applies.</div>
                </div>
            </section>

            <section className="panel mt-3">
                <h2>Ad analytics (preview)</h2>
                <p className="text-muted">A quick summary of recent impressions and clicks.</p>
                <AdminAds />
            </section>
        </div>
    );
}

export default AdminPanel;
